import React, { Component } from 'react'
import styles from './paintingBespoke.module.scss'
import { connect } from "react-redux";
import defaultImage from '../../../assets/default.png';

class FlooringBespoke extends Component<any,any> {
    render() {
        const { pageDetails } = this.props;
        const flooringDetails = {"PRODUCT NAME":"","CODE NUMBER":"","AREA":"","NO OF BOXES":""}
        const flooringDetails2 = {"REDUCER":"","QUARTER ROUND":"","SKIRTING":"","T-MODELLING":""}
        return (
            <React.Fragment>
            <div className="page-image-container" style={{background:'#fff'}}>
                <div className="page-heading">{pageDetails?.name}</div>
                <div className="image-section-container">
                    {/* <img crossOrigin="anonymous" src={''} alt="" className="image-view" /> */}
                </div>
            </div>
            <div className="details-heading">FLOORING SPECIFICATIONS</div>
            <div className={styles["tables-alignment"]} style={{margin: "15px"}}>
                    <div className={styles.Table}>
                        <div className={styles.Row}>
                            <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                <p><b>FLOORING DETAILS</b></p>
                            </div>
                            <div className={styles['Cell']+" "+styles['headings']} style={{borderLeft: "none"}}>
                                <p><b></b></p>
                            </div>
                        </div>
                        {
                            flooringDetails && Object.keys(flooringDetails).map(key=>{
                                return(
                                    <div key={key} className={styles.Row}>
                                        <div className={styles['Cell']+" "+styles['headings']}>
                                            <p>{key.replace(/_/g, " ").toString().toUpperCase()}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{flooringDetails[key].toString().toUpperCase()}</p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        
                    </div> 
                    <div className={styles.Table}>
                        <div className={styles.Row}>
                            <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                <p><b>FLOORING ACCESSORY DETAILS</b></p>
                            </div>
                            <div className={styles['Cell']+" "+styles['headings']} style={{borderLeft: "none"}}>
                                <p><b></b></p>
                            </div>
                        </div>
                        {
                            flooringDetails2 && Object.keys(flooringDetails2).map(key=>{
                                return(
                                    <div key={key} className={styles.Row}>
                                        <div className={styles['Cell']+" "+styles['headings']}>
                                            <p>{key.replace(/_/g, " ").toString().toUpperCase()}</p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p>{flooringDetails2[key].toString().toUpperCase()}</p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>    
                    <div className={styles.Table}>
                                <div className={styles.Row}>
                                    <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                        <p><b>FLOORING INSTALLATION</b></p>
                                    </div>
                                    <div className={styles['Cell']+" "+styles['headings']} style={{borderLeft: "none"}}>
                                        <p><b></b></p>
                                    </div>
                                </div>
                                <div className={styles.Row}>
                                    <div className={styles['Cell']+" "+styles['headings']}>
                                        <p>PATTERN</p>
                                    </div>
                                    <div className={styles.Cell}>
                                        <p></p>
                                    </div>
                                </div>
                                <div className={styles.Row}>
                                    <div className={styles['Cell']+" "+styles['headings']}>
                                        <p>FOAM</p>
                                    </div>
                                    <div className={styles.Cell}>
                                        <p></p>
                                    </div>
                                </div>
                        </div>   
                        <div className={styles.Table}>
                                <div className={styles.Row} style={{width:'50%'}} >
                                    <div className={styles['Cell']+" "+styles['headings']}>
                                        <p>{"Flooring Image"}</p>
                                        {/* {
                                            wallpaperImage[0] ? <img src={wallpaperImage[0]} width="100px" height="80px" />:""
                                        } */}
                                        <img alt="default Img" src={defaultImage} width="100px" height="80px" />
                                    </div>
                                    <div className={styles['Cell']+" "+styles['headings']}>
                                        <p>{"Pattern Image"}</p>
                                        {/* {
                                            wallpaperImage[1] ? <img src={wallpaperImage[1]} width="100px" height="80px" />:""
                                        } */}
                                        <img alt="default Img" src={defaultImage} width="100px" height="80px" />
                                    </div>
                                </div>
                        </div>
                </div>
                </React.Fragment>
        )
    }
}

export default connect(
    (state: any) => ({
        pageDetails: state.wizard.pageDetails
    }),
    {
    }
)(FlooringBespoke);